import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Card, Table, Pagination, Badge, Button, Alert, Spinner, Form } from '@themesberg/react-bootstrap';
import api from '../../utils/api';
import { useHistory } from 'react-router-dom';

export default () => {
  const history = useHistory();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    loadPackages();
  }, []);

  const loadPackages = async () => {
    try {
      setLoading(true);
      const response = await api.get('/packages/vip');
      const packagesList = Array.isArray(response.data?.packages)
        ? response.data.packages
        : (Array.isArray(response.data) ? response.data : []);
      // Backend orderBy order asc yapmıyorsa client side'da yapalım:
      packagesList.sort((a, b) => (a.order || 0) - (b.order || 0));
      setPackages(packagesList.map(pkg => ({ ...pkg, id: pkg.id || pkg._id })));
      setError(null);
    } catch (err) {
      console.error("Error loading VIP packages:", err);
      setError("Paketler yüklenirken hata oluştu: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (packageId) => {
    if (!window.confirm("Bu VIP paketi silmek istediğinize emin misiniz?")) {
      return;
    }

    try {
      setDeletingId(packageId);
      await api.delete(`/packages/vip/${packageId}`);
      setPackages(packages.filter(pkg => pkg.id !== packageId));
    } catch (err) {
      console.error("Error deleting VIP package:", err);
      alert("Paket silinirken hata oluştu: " + err.message);
    } finally {
      setDeletingId(null);
    }
  };

  const handleEdit = (packageId) => {
    history.push(`/packages/vip/edit/${packageId}`);
  };

  const handleToggleVisible = async (pkgId, currentVisible) => {
    try {
      const newVisible = !currentVisible;
      await api.put(`/packages/vip/${pkgId}`, {
        visible: newVisible
      });
      setPackages(packages.map(pkg =>
        pkg.id === pkgId ? { ...pkg, visible: newVisible } : pkg
      ));
    } catch (err) {
      console.error("Error toggling visibility:", err);
      alert("Görünürlük güncellenirken hata oluştu: " + err.message);
    }
  };

  return (
    <>
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.9rem' }}>
                  <thead>
                    <tr>
                      <th style={{ width: '50px' }}>#</th>
                      <th>Paket İsmi</th>
                      <th>Ücret</th>
                      <th>SKU</th>
                      <th>Kredi</th>
                      <th>Sıra No</th>
                      <th style={{ width: '150px' }}>Durum</th>
                      <th style={{ width: '120px' }}>İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {packages.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center p-4">
                          Henüz VIP paket eklenmemiş.
                        </td>
                      </tr>
                    ) : (
                      packages.map((pkg, index) => (
                        <tr key={pkg.id}>
                          <td className="text-center">{index + 1}</td>
                          <td>{pkg.packageName}</td>
                          <td>{pkg.price} TL</td>
                          <td>{pkg.sku}</td>
                          <td>{pkg.days}</td>
                          <td>{pkg.order}</td>
                          <td>
                            {pkg.visible !== false ? (
                              <Badge bg="success" className="mb-2 d-block">Aktif</Badge>
                            ) : (
                              <Badge bg="secondary" className="mb-2 d-block">Pasif</Badge>
                            )}
                            <Button
                              variant={pkg.visible !== false ? "outline-warning" : "outline-success"}
                              size="sm"
                              className="w-100"
                              onClick={() => handleToggleVisible(pkg.id, pkg.visible !== undefined ? pkg.visible : true)}
                            >
                              {pkg.visible !== false ? "Pasife Al" : "Aktife Al"}
                            </Button>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="light"
                                size="sm"
                                className="p-1"
                                style={{ width: '32px', height: '32px' }}
                                onClick={() => handleEdit(pkg.id)}
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </Button>
                              <Button
                                variant="light"
                                size="sm"
                                className="p-1"
                                style={{ width: '32px', height: '32px' }}
                                onClick={() => handleDelete(pkg.id)}
                                disabled={deletingId === pkg.id}
                              >
                                {deletingId === pkg.id ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  <FontAwesomeIcon icon={faTrash} />
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
